import { fetch } from '../../Common/fetch';
import { Id } from '../../Common/interfaces';
import {
    CreateOrUpdateLogbookPersonalEntryRequest,
    ExerciseDto,
    LogbookPersonalEntryDto,
    ModuleDto,
    ReportExerciseProgressRequest,
} from './interfaces';

export async function getExercises(moduleId: number): Promise<ExerciseDto[]> {
    return fetch(`/api/modules/${moduleId}/exercises`);
}

export async function reportExerciseProgress(
    moduleId: number,
    exerciseId: number,
    request: ReportExerciseProgressRequest,
): Promise<ExerciseDto[]> {
    return fetch(
        `/api/modules/${moduleId}/exercises/${exerciseId}`,
        'post',
        request,
    );
}

export async function reportExerciseClosed(
    moduleId: Id<ModuleDto>,
    exerciseId: Id<ExerciseDto>,
    pageNumber: number,
) {
    return fetch(
        `/api/modules/${moduleId.Value}/exercises/${exerciseId.Value}/closed/${pageNumber}`,
        'post',
    );
}
export async function reportExerciseBackNavigation(
    moduleId: Id<ModuleDto>,
    exerciseId: Id<ExerciseDto>,
    pageNumber: number,
) {
    return fetch(
        `/api/modules/${moduleId.Value}/exercises/${exerciseId.Value}/navigated-back/${pageNumber}`,
        'post',
    );
}

export async function reportMediaStarted(
    moduleId: Id<ModuleDto>,
    exerciseId: Id<ExerciseDto>,
    mediaUrl: string,
    timestamp: number,
) {
    return fetch(
        `/api/modules/${moduleId.Value}/exercises/${exerciseId.Value}/media-started`,
        'post',
        { mediaUrl, timestamp: Math.floor(timestamp) },
    );
}
export async function reportMediaPaused(
    moduleId: Id<ModuleDto>,
    exerciseId: Id<ExerciseDto>,
    mediaUrl: string,
    timestamp: number,
) {
    return fetch(
        `/api/modules/${moduleId.Value}/exercises/${exerciseId.Value}/media-paused`,
        'post',
        { mediaUrl, timestamp: Math.floor(timestamp) },
    );
}
export async function reportMediaFinished(
    moduleId: Id<ModuleDto>,
    exerciseId: Id<ExerciseDto>,
    mediaUrl: string,
) {
    return fetch(
        `/api/modules/${moduleId.Value}/exercises/${exerciseId.Value}/media-finished`,
        'post',
        { mediaUrl },
    );
}

export async function getLogbookPersonalEntry(): Promise<
    LogbookPersonalEntryDto[]
> {
    return fetch(`/api/modules/personal-notes`, 'get');
}

export async function createOrUpdateLogbookPersonalEntry(
    item: CreateOrUpdateLogbookPersonalEntryRequest,
) {
    return fetch(`/api/modules/personal-notes`, 'post', item);
}

export async function deleteLogbookPersonalEntry(noteId: number) {
    return fetch(`/api/modules/personal-notes/${noteId}`, 'delete');
}

export async function getExercise(exerciseId: number): Promise<ExerciseDto> {
    return fetch(`/api/modules/exercises/${exerciseId}`, 'get');
}
